<template lang="pug">
div
	page-header(:title='title')
	form(@submit.prevent='gravar')
		.modal-body
			.form-horizontal
				vue-element-loading(:active='isActive', spinner='bar-fade-scale', color='#428BCA')
				input-form-text(textInput='Título', :required='true', v-model='form.pregao_titulo', :value='form.pregao_titulo')
				input-form-text(textInput='Link', :required='true', v-model='form.pregao_url', :value='form.pregao_url')
				.form-group
					select-form(v-model='form.pregao_ativo', :value='form.pregao_ativo', name='Ativo', url='/arquivos', id='id', titulo='nome', layout='true', optionText='Selecione', required='true')
		footer-button(:disabled='isActive')
</template>

<script>
import { mapGetters } from 'vuex'
import VueElementLoading from 'vue-element-loading'
import { onValue } from 'firebase/database'
import PageHeader from '@/components/PageHeader'
import InputFormText from '@/components/form/InputForm'
import SelectForm from '@/components/form/SelectForm'
import FooterButton from '@/components/form/FooterButton'
import dataService from '@/services/dataBase'
import { sucesso } from '@/components/Message'

export default {
	components: {
		VueElementLoading,
		PageHeader,
		InputFormText,
		SelectForm,
		FooterButton
	},
	computed: {
		...mapGetters([
			'user'
		])
	},
	data() {
		return {
			title: 'Pregão Online',
			form: {
				pregao_titulo: '',
				pregao_url: '',
				pregao_ativo: '1',
				uuid: 0
			},
			isActive: false
		}
	},
	methods: {
		create_UUID() {
            var dt = new Date().getTime()
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (dt + Math.random() * 16) % 16 | 0
                dt = Math.floor(dt / 16)
                return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16)
            })
            return uuid
        },
		async gravar() {
			const data = {
                pregao_titulo: this.form.pregao_titulo,
                pregao_url: this.form.pregao_url,
                pregao_ativo: this.form.pregao_ativo,
                uuid: this.form.uuid
            }
            await dataService.update('pregao', data, data.uuid)
			sucesso('Atualizado...')
		},
		onDataChange(items) {
			this.form.uuid = items[0][1].uuid
			this.form.pregao_titulo = items[0][1].pregao_titulo
			this.form.pregao_url = items[0][1].pregao_url
			this.form.pregao_ativo = items[0][1].pregao_ativo
			this.isActive = false
		},
	},
	async created() {
		this.isActive = true
		const dados = await dataService.getAll('pregao')
		onValue(dados, (snapshot) => {
			const data = snapshot.val()
			if (data)
				this.onDataChange(Object.entries(data))
			this.isActive = false
		})
	},
	beforeDestroy() {
		dataService.off()
	}
}
</script>

<style lang="stylus" scoped>

</style>
